import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptAnnouncements } from "../adapters/adaptAnnouncements";

interface FetchParams {
	page: number;
	pageSize: number;
	status?: string;
	search?: string;
	audienceGroupId?: number;
	onlyEveryone?: boolean;
}

const fetchAnnouncementsPaged = async ({
	page,
	pageSize,
	status,
	search,
	audienceGroupId,
	onlyEveryone
}: FetchParams) => {
	const response = await cmsClient.get<CMSPaginatedData<IAnnouncement>>(
		"/announcements/",
		{
			params: {
				page,
				page_size: pageSize,
				status: status || undefined,
				search: search || undefined,
				audience_group_id: audienceGroupId ?? undefined,
				only_everyone: onlyEveryone ? true : undefined
			}
		}
	);

	return response.data;
};

const useAnnouncementsPaged = (
	page: number,
	pageSize: number,
	status?: string,
	search?: string,
	audienceGroupId?: number,
	onlyEveryone?: boolean
) => {
	return useQuery(
		[
			"announcements",
			{ page, pageSize, status, search, audienceGroupId, onlyEveryone }
		],
		() =>
			fetchAnnouncementsPaged({
				page,
				pageSize,
				status,
				search,
				audienceGroupId,
				onlyEveryone
			}),
		{
			keepPreviousData: true,
			select: (data) => ({
				...data,
				results: adaptAnnouncements(data.results)
			})
		}
	);
};

export default useAnnouncementsPaged;
